import React from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'

type Props = {
    children: any,
    className?: string,
    backgroundColor?: string
}

export const FireBackground = ({
    children,
    className,
    backgroundColor
}: Props) => (
    <Background className={className} backgroundColor={backgroundColor}>
        {children}
    </Background>
)

const Background = styled.div`
    background-position: right bottom;
    background-repeat: no-repeat;
    &.splitscreen {
        background-color: ${props => props.backgroundColor || colors.chalk};
        padding-bottom: 50px;
        ${media.medium`
            padding-bottom: 100px;
        `};
    }
`
